// Set right before redirecting to PayPal for an SMS bundle purchase, read
// back on /processing-payment/sms-success (and cleared on /sms-cancel) since
// bundleId isn't part of PayPal's redirect query string.
export const PENDING_SMS_BUNDLE_KEY = "rs_pending_sms_bundle";

export const subscriptionsTier ={
    free:{
        yearly:0,
        monthly:0
    },
    rmanager:{
        yearly:179.99,
        monthly:19.99
    },
    basic:{
        yearly:342,
        monthly:39.99
    },

}